export const ACTION_POINTS_VALUES = {
  ACTION: 50,
  ACTION_ITEM: 2,
  BONUS_FULL: 5,
  BONUS_PARTIAL: 2,
};
